import React from 'react';
interface TestimonialCardProps {
  initials: string;
  stars: number;
  quote: string;
  name: string;
  location: string;
  level: string;
}
function TestimonialCard({
  initials,
  stars,
  quote,
  name,
  location,
  level
}: TestimonialCardProps) {
  return <div className="bg-black border border-[#F97316]/30 rounded-2xl p-6 flex flex-col gap-4" data-id="element-398">
      <div className="flex items-center gap-3" data-id="element-399">
        <div className="w-12 h-12 rounded-full bg-[#F97316]/20 border border-[#F97316]/40 flex items-center justify-center text-[#F97316] font-black text-sm flex-shrink-0" data-id="element-400">
          {initials}
        </div>
        <div data-id="element-401">
          <div className="text-[#F97316] text-sm" data-id="element-402">{'⭐'.repeat(stars)}</div>
          <div className="text-white font-bold text-sm" data-id="element-403">{name}</div>
          <div className="text-gray-400 text-xs" data-id="element-404">
            📍 {location} | {level}
          </div>
        </div>
      </div>
      <p className="text-gray-300 text-sm leading-relaxed italic" data-id="element-405">"{quote}"</p>
    </div>;
}
export function TestimonialsSection() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-406">
      <div className="max-w-5xl mx-auto" data-id="element-407">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-4" data-id="element-408">
          Lo que dicen los entrenadores que ya lo usan:
        </h2>
        <p className="text-gray-400 text-center mb-10" data-id="element-409">
          Entrenadores de básquet de toda la región ya tienen su MegaPack
          EduLabs
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-410">
          <TestimonialCard initials="MR" stars={5} quote="Compré un domingo a la noche. El lunes entré al gimnasio con el plan exacto del entrenamiento. Las 50 sesiones del Tomo 1 son exactamente lo que necesitaba para mis chicos de U12. Nunca más improviso." name="Marcelo R." location="Buenos Aires, Argentina" level="Entrenador de Club" data-id="element-411" />
          <TestimonialCard initials="JG" stars={5} quote="El sistema del Tomo 3 con U17 me cambió todo. El primer mes, tres jugadores que llevaban meses estancados mejoraron visiblemente su lectura táctica. Los drills del Tomo 5 hacen la diferencia. Los uso en cada entrenamiento." name="Jorge G." location="Ciudad de México, México" level="DT en Academia" data-id="element-412" />
          <TestimonialCard initials="SV" stars={5} quote="El Tomo 5 de Drills es único en el mercado. 101 ejercicios listos para usar clasificados por objetivo. Antes tardaba 1 hora en armar un entrenamiento de tiro. Ahora abro el PDF de EduLabs y en 5 minutos tengo todo listo." name="Sofía V." location="Bogotá, Colombia" level="Profesora de Educación Física" data-id="element-413" />
          <TestimonialCard initials="FL" stars={5} quote="El sistema de métricas del Bono 4 eliminó las discusiones con los padres sobre si su hijo mejora. Ahora lo muestro con datos. Y los padres renovaron todos sin preguntar." name="Fernando L." location="Lima, Perú" level="Entrenador de Club Formativo" data-id="element-414" />
          <TestimonialCard initials="LP" stars={5} quote="La tasa de abandono de mis categorías menores bajó notablemente. Sin cambiar lo que enseño. Solo aplicando el sistema de cohesión del Bono 5 y la planificación del Tomo 1. Los jugadores ahora quieren venir." name="Laura P." location="Montevideo, Uruguay" level="Entrenadora de Básquet" data-id="element-415" />
          <TestimonialCard initials="VT" stars={5} quote="El Banco de Mensajes del Bono 2 me salvó de discusiones con padres que no entendían por qué su hijo no jugaba más. Ahora tengo el guión listo. Lo copio, lo pego y cierro el tema en 2 mensajes." name="Valeria T." location="Caracas, Venezuela" level="Entrenadora de Club" data-id="element-416" />
          <TestimonialCard initials="AR" stars={5} quote="El Kit de Adaptación del Bono 3 me salvó cuando teníamos el gimnasio en obras 3 semanas. Antes perdía esas sesiones. Con el kit de EduLabs di 12 entrenamientos adaptados en espacios alternativos. Los jugadores no perdieron nada." name="Ana R." location="Guadalajara, México" level="Instructora en Club" data-id="element-417" />
        </div>
      </div>
    </section>;
}